import type { MouseEventHandler, ReactNode } from "react";

import { StyledFilterButton } from "./styles";
import { FilterButtonVariant } from "./FilterButton.types";

type FilterButtonProps = {
    variant?: FilterButtonVariant;
    children: ReactNode;
    onClick: MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
};

const FilterButton = ({ variant = FilterButtonVariant.default, children, onClick, disabled }: FilterButtonProps) => (
    <StyledFilterButton
        type="button"
        onClick={disabled ? undefined : onClick}
        variant={variant}
    >
        {children}
    </StyledFilterButton>
);

export default FilterButton;
export { FilterButtonVariant } from "./FilterButton.types";
